import { apiConstants } from "@data/constants/apiConstants"
import { tutorMonthlyScoreConstants } from "@data/constants/tutorMonthlyScoreConstants"
import { tutorMonthlyScoreService } from "@data/services/tutorMonthlyScoreService"
import { authConstants } from "@data/constants/authConstants"
import { authService } from "@data/services/authService"

const initialState = {
    myMonthlyScore: null,
    myPreviousMonthScore: null,
    myGlobalScore: null,
    viewedTutorScore: null,
    viewedTutorPreviousMonthScore: null,
    viewedTutorGlobalScore: null,
    previousMonthScore: null,
    shouldShowResetModal: false,
    bonusInfo: null,
    trialConversionStats: null,
    previousMonthTrialConversionStats: null,
    globalTrialConversionStats: null,
    viewedTutorTrialConversionStats: null,
    viewedTutorPreviousMonthTrialConversionStats: null,
    viewedTutorGlobalTrialConversionStats: null,
}

export function tutorMonthlyScore(state = initialState, action) {
    switch (action.type) {
        case tutorMonthlyScoreConstants.HIDE_RESET_MODAL:
            return {
                ...state,
                shouldShowResetModal: false,
            }

        // Unified endpoint for tutor
        case tutorMonthlyScoreService.getAllScores.name + apiConstants._SUCCESS:
            return {
                ...state,
                myMonthlyScore: action.data.currentMonth,
                myPreviousMonthScore: action.data.previousMonth,
                myGlobalScore: action.data.global,
                bonusInfo: action.data.bonusInfo,
                shouldShowResetModal:
                    action.data.modalInfo?.shouldShowModal || false,
                previousMonthScore:
                    action.data.modalInfo?.previousMonthScore || null,
                trialConversionStats:
                    action.data.trialConversionStats?.currentMonth || null,
                previousMonthTrialConversionStats:
                    action.data.trialConversionStats?.previousMonth || null,
                globalTrialConversionStats:
                    action.data.trialConversionStats?.global || null,
            }

        // Unified endpoint for admin
        case authConstants.LOGOUT_401:
        case authConstants.RESET_AUTH_STATE:
        case authService.logout.name + apiConstants._SUCCESS:
        case authService.revokeSanctumToken.name + apiConstants._SUCCESS:
        case authService.deleteAccount.name + apiConstants._SUCCESS:
            return initialState

        default:
            return state
    }
}
